import React from 'react';
import {Segment, Header} from 'semantic-ui-react';
import CommentList from 'go/components/comments/CommentList';

export default class CommentController extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      comments: [],
      filterBy: {
        // todo add filter booleans here
      },
      sortBy: {
        // todo add sortBy booleans here
      },
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    // we can set filters/ sorts here if they are passed by another controller
    prevState.comments = nextProps.comments;
    return prevState;
  }

  renderHeader(header) {
    return <Header as="h1">{header}</Header>;
  }

  renderControls() {
    return <React.Fragment />;
  }

  render() {
    const {header, controls} = this.props;
    // will need to come from the sorted, filtered subset in future, all comments for now
    const {comments} = this.state;
    return (
      <Segment>
        {header && this.renderHeader(header)}
        {controls && this.renderControls()}
        <CommentList comments={comments} />
      </Segment>
    );
  }
}
